import smartSolveApi from './instances/smartsolve';

export const getDocumentRepositories = async () => {
  try {
    const response = await smartSolveApi.post('/getdocumentrepositories', {});

    return response.data;
  } catch (e) {
    throw new Error(`getDocumentRepositories() failed: ${e}`);
  }
};

export const getDocumentRepositoryDetails = async (params) => {
  try {
    const response = await smartSolveApi.post('/getdocumentrepositorydetails', params);
    return response.data;
  } catch (e) {
    throw new Error(`getDocumentRepositoryDetails() failed: ${e}`);
  }
};

export const setPersonalDefaultRepository = async (id) => {
  try {
    const response = await smartSolveApi.post('/setRepositoryAsDefault', id, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(`setPersonalDefaultRepository() failed: ${e}`);
  }
};

export const removePersonalDefaultRepository = async (id) => {
  try {
    const response = await smartSolveApi.post('/removeRepositoryAsDefault', id, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(`removePersonalDefaultRepository() failed: ${e}`);
  }
};

export const downloadSelectedDocuments = async (documentsIds = []) => {
  try {
    const response = await smartSolveApi.post(
      '/DownLoadSelectedDocument',
      {
        Ids: documentsIds,
      },
      {
        responseType: 'blob',
      }
    );

    return response;
  } catch (e) {
    throw new Error(`downloadSelectedDocuments() failed: ${e}`);
  }
};
